
import Vue from "vue";
export default Vue.extend({
  props: { small: Boolean, medium: Boolean, large: Boolean },
});
